import { SPECIFIC_ADDON_PRODUCT_EXCEPTION } from './fortune/error-code'

/** -- 加價購 Error Codes -- */
export const ADDON_V2_ERROR_CODES = {
  /** 找不到此加購商品 */
  ADDON_V2_PRODUCT_NOT_FOUND: 22001,
  /** 您的消費金額尚未達到加購門檻 */
  CRITERION_AMOUNT_NOT_MET: 22003,
  /** 您已達加購商品的購買上限 */
  ADDON_PURCHASE_LIMIT_EXCEEDED: 22006,
  /** 已達加購商品(parent)的購買上限 */
  ADDON_EXCEED_PARENT_PRODUCT_LIMIT: 22009,

} as const

export const ERROR_CODES = {
  /** 晚來了一步...優惠卷已領取完畢 */
  TICKET_ISSUANCE_IS_DONE: 10014,
  /** 領取期限已過 */
  TICKET_END_PERIOD: 10015,
  /** 無效參數 */
  INVALID_PARAMETERS: 5300,
  /** 揀貨單檔案生成中 */
  ORDER_BATCH_GENERATING_FILES: 21001,
  /** ATM、超商付款訂單取消 */
  ATM_CVS_PAYME_PAYMENT_ORDER_CANCEL: 16001,
  /** 登入異常，帳號無經銷角色，請洽負責業務 */
  LOGIN_ERROR_NO_SALES_ROLE: 5100,
  /** 登入異常，合作狀態異常請聯繫負責業務或官方LINE */
  LOGIN_ERROR_PARTNER_STATUS_ERROR: 20002,
  /** 登入異常，此站台不符合您的合作地區，請聯繫負責業務或官方LINE */
  LOGIN_ERROR_PARTNER_REGION_ERROR: 20003,
  ...ADDON_V2_ERROR_CODES,
  ...SPECIFIC_ADDON_PRODUCT_EXCEPTION,
} as const

export const BINDING_ERROR_CODES = {
  /** LINE 重複綁定 */
  LINE_REPEAT_BIND: 400031,
  /** Facebook 重複綁定 */
  FACEBOOK_REPEAT_BIND: 400032,
  /** Google 重複綁定 */
  GOOGLE_REPEAT_BIND: 400033,
}

/** LINE 訂閱 OAuth 回跳失敗時，後端 append 在 fallbackUrl `code` 參數上的錯誤碼 */
export const LINE_SUBSCRIPTION_ERROR_CODES = {
  /** 已確認未加 LINE 官方帳號好友 → 引導加好友 */
  NOT_FRIEND: 400181,
  /** LINE 授權失敗或好友狀態查詢失敗（逾時/限流）→ 一般性失敗、可重試；使用者可能已是好友，勿套「請先加好友」文案 */
  AUTH_ERROR: 400180,
  /** 訂閱寫入失敗 → 一般性失敗、可重試 */
  WRITE_FAILED: 400037,
} as const

export const CANCELABLE_ERROR_CODES = {
  /** 準備出貨，無法取消 */
  NONCANCELLABLE_SHIPMENT_READY: 16008,
  /** 揀貨中，無法取消 */
  NONCANCELLABLE_SHIPMENT_CREATING: 16009,
  /** 手動付款（ATM/超商代碼/PayMe），不支援自行取消 */
  NONCANCELLABLE_VIRTUAL_ACCOUNT: 16010,
} as const

export const BIND_CARD_ERROR_CODES = {
  /** 無效參數 */
  INVALID_PARAMETERS: 5300,
  /** 金流商錯誤 */
  PAYMENT_GATEWAY_ERROR: 13001,
} as const

export const ORDER_BATCHES_ERROR_CODES = {
  /** 無效參數 */
  INVALID_PARAMETERS: 5300,
  /** 權限不足錯誤 */
  PERMISSION_DENY: 5100,
} as const

export const GUEST_ORDER_CLAIM_ERROR_CODES = {
  /** 訂單點數已領取過，不可再領取 */
  ORDER_ALREADY_CLAIMED: 28002,
} as const
